import React, { useEffect, useState } from "react";
import PilotChatList from "components/pilot/PilotChatList";
import PilotConversation from "components/pilot/PilotConversation";
import "components/pilot/pilot.css";

// Below Tailwind's md: no room for the list beside the chat.
const SMALL_SCREEN = "(max-width: 767px)";

// Each admin's own chats with Pilot about the platform. On a small screen the list is the agent app's history: opened
// from the clock in the bar, in the chat's place, and closed by picking a chat or starting one.
const Pilot = () => {
  const [openChatId, setOpenChatId] = useState(null);
  const [isSmallScreen, setIsSmallScreen] = useState(() => window.matchMedia(SMALL_SCREEN).matches);
  const [historyOpen, setHistoryOpen] = useState(false);

  useEffect(() => {
    const query = window.matchMedia(SMALL_SCREEN);
    const onChange = (event) => setIsSmallScreen(event.matches);
    query.addEventListener("change", onChange);
    return () => query.removeEventListener("change", onChange);
  }, []);

  const chatList = (
    <PilotChatList
      openChatId={openChatId}
      onOpen={(chatId) => {
        setOpenChatId(chatId);
        setHistoryOpen(false);
      }}
      onNewChat={() => {
        setOpenChatId(null);
        setHistoryOpen(false);
      }}
      onDeleted={(chatId) => setOpenChatId((current) => (current === chatId ? null : current))}
      asPanel={isSmallScreen}
    />
  );

  return (
    <div className="pilot-page container mx-auto pb-4">
      <div
        className="flex overflow-hidden rounded border border-mediumgray bg-white"
        style={{ height: "calc(100vh - 100px)" }}
      >
        {!isSmallScreen && chatList}
        <PilotConversation
          chatId={openChatId}
          onChatStarted={setOpenChatId}
          history={
            isSmallScreen
              ? {
                  isOpen: historyOpen,
                  onToggle: () => setHistoryOpen((open) => !open),
                  onClose: () => setHistoryOpen(false),
                  panel: chatList,
                }
              : undefined
          }
        />
      </div>
    </div>
  );
};

export default Pilot;
